import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

import { ABTestingMatrix } from "./ab-testing-matrix";

export function useABTestingGAUserProperties(): useABTestingGAUserPropertiesReturn {
  return useLazyContext(ABTestingGAUserPropertiesContext);
}

export type useABTestingGAUserPropertiesReturn = {
  updateMatrix: (properties: ABTestingMatrix) => void;
};

export const ABTestingGAUserPropertiesContext =
  createContext<LazyValue<useABTestingGAUserPropertiesReturn>>(undefined);
